import { setEntryNote } from '../../Utils/Api';

import CountedSimpleEditor from './CountedSimpleEditor';
import React from 'react';

export default function NotesEditor({ awardId, entryId, content, categoryId = null, handleChange = ()=>{} }) {

    if((awardId === null || entryId === null) && content === null) {
        throw new Error("Either content or awardId and entryId are required props.");
    }

    const [state, setState] = React.useState({
        content: content ?? "",
    });

    const debouncedSetEntryNote = React.useMemo(
        () => 
            debounce(
                this, 
                (awardId, entryId, content, categoryId = null) => 
                    setEntryNote({
                        awardId,
                        entryId,
                        categoryId,
                        note: content,
                    })
                        .then(resp => {
                            if(resp.status === 200 && resp.data && resp.data.success === "OK") {
                                // successfully saved
                                /*setState(s => ({
                                    ...s,
                                    notes: resp.data.notes.map(note => ({
                                        ...note,
                                    })),
                                }))*/
                            }
                        }),
                1000
            ), 
        []
    );

    function _handleChange(e, content) {

        debouncedSetEntryNote(awardId, entryId, content, categoryId);
        
        setState({
            ...state,
            content: content,
        });

        handleChange.call(this, e, content);
    }
    
    return (
        <CountedSimpleEditor 
            content={state.content} 
            handleChange={_handleChange} 
            maxLength={1000} 
            placeholder="Enter your notes here..." 
        />
    );
}

/**
 * @param {*} ctx The context
 * @param {function} func The function to execute after the debounce time
 * @param {number} delay The amount of time to wait
 * @return {function} The debounced function
 */
function debounce(context, func, delay) {
    let timeout;

    return (...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
};